import { useAFormHandler } from 'analytics/hooks'
import { useFormik } from 'formik'
import { refetchFunc } from 'modules/domain/common/hooks'
import { apiClient } from 'modules/utils/httpClient'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { FormDatePicker } from 'views/components/form/FormDatePicker'
import { FormGroupUpload } from 'views/components/FormGroupUpload/FormGroupUpload'
import { ResponsiveModal } from 'views/components/ResponsiveModal/ResponsiveModal'
import { SharedModalInputs } from 'views/components/SharedModal'

type Props = {
  refetch: refetchFunc
  onClose: () => void
  uploadUrl: string
  documentType: string
}

type Fields = {
  valid_until: string
  files: string[][]
}

export const AddDriverDocModal: FC<Props> = ({ onClose, uploadUrl, refetch, documentType }) => {
  const { t } = useTranslation('logisticsKR')
  const { formProgress, formHandler } = useAFormHandler()

  const isDriverlicence = documentType === 'driving_licence'

  const formik = useFormik<Fields>({
    initialValues: {
      files: [],
      valid_until: '',
    },

    onSubmit: formHandler(
      async () => {
        const dto = {
          document_type: documentType,
          files: formik.values.files,
          ...(isDriverlicence ? {} : { valid_until: formik.values.valid_until }),
        }
        await apiClient.post(uploadUrl, dto)
      },
      {
        onSuccess: async () => {
          await refetch()
          onClose()
        },
        onError: (error) => {
          const { errors } = error
          formik.setErrors(errors)
        },
      },
    ),
  })

  return (
    <ResponsiveModal
      onConfirm={() => formik.handleSubmit()}
      title={t('driverDocUploadTitle')}
      confirmButtonText={t('common:save')}
      progress={formProgress}
      id="addDriverDoc"
      onClose={onClose}
    >
      <SharedModalInputs>
        {!isDriverlicence && (
          <FormDatePicker formik={formik} label={t('validUntil')} fieldName="valid_until" id="valid_until" />
        )}
        <FormGroupUpload label={t('common:files')} formik={formik} fieldName="files" maxWidthFileUpload={411} />
      </SharedModalInputs>
    </ResponsiveModal>
  )
}
